import { SET_OFFER_RELATED, REMOVE_OFFER_RELATED, PUSH_OFFER_RELATED } from '../constants/related-offers';

const initialState = {
  offerList: [],
};

const relatedOffersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OFFER_RELATED:
      return {
        ...state,
        offerList: [...action.list]
      };
    case REMOVE_OFFER_RELATED:
      return {
        ...state,
        offerList: state.offerList.filter(o => o.id !== action.id),
      }
    case PUSH_OFFER_RELATED:
      return {
        ...state,
        offerList: state.offerList.concat(action.data),
      };
    default:
      return state;
  }
};

export default relatedOffersReducer;